import React, { memo } from 'react';
import EditableCell from './EditableCell';

export default (props) => {
  const cellObject = props.value;

  // Handle case where cellObject is not an array (e.g., after invalid paste)
  // This is to protect against grid crashing when pasted in labels column and then trying to edit a cell
  if (!Array.isArray(cellObject)) {
    return (
      <EditableCell gridProps={props} wrapperClassName='grid-dropdown-cell-renderer' iconClassName='caret'>
        {''}
      </EditableCell>
    );
  }

  // TODO: Dupe in MultiSelectCellRenderer
  const valueNode = cellObject.map((item) => {
    const color = item.color ? item.color : '#888';
    const style = {
      borderColor: color,
      backgroundColor: color,
      padding: '0px 2px',
      marginRight: '3px',
    };

    return <span key={item.value} className="badge" style={style}>{item.value}</span>;
  });

  return (
    <EditableCell gridProps={props} wrapperClassName='grid-dropdown-cell-renderer' iconClassName='caret'>
      {valueNode}
    </EditableCell>
  );
};
